import React from "react";
import styled from "styled-components";
import PeriodMetric from "../../../ourprogramme/header/PeriodMetric";
import AvailablePeriods from "../../../ourprogramme/header/AvailablePeriods";
import {PortfolioDetails} from "./PortfolioDetails";
import {AuthorKpiHeading} from "./AuthorKpi";
import {PortfolioMessage} from "./PortfolioMessage";
import BackToPage from "../../../elements/BackToPage";
import {Clock, LocalDate} from "js-joda";

const Container = styled.div`
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    
    background-color: #f0ece9;
    border-bottom: solid 1px #e1dbd5;
    box-shadow: 0 6px 10px 0 #d4d4d4;
    z-index: 1;
`;

const Controls = styled.div`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    background-color: #f5f2f0;
    border-bottom: solid 1px #e2dede;
    height: 36px;
    padding-left: 18px;
    padding-right: 18px;
`;

const BackButtonContainer = styled.div`
    flex-grow: 1;
`;

const Details = styled.div`    
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    align-items: flex-start;
    justify-content: stretch;
    padding-top: 10px;
    padding-left: 18px;
    padding-right: 18px;
    height: 92px;
`;

const PortfolioAuthorHeader = ({portfolioAuthor, portfolioAuthorActions, authorId}) => {
    const {portfolioId, portfolioName, performancePeriod, performancePeriodStart, rewardPeriod, availablePeriods, portfolioMessage} = portfolioAuthor;

    const viewingOnDate = LocalDate.now(Clock.systemDefaultZone());

    function loggingPayloadFor(period) {
        const {periodBasis, startDate} = period;

        return {
            type: "REWARD_PERIOD_SELECTED",
            portfolioId,
            portfolioName,
            periodBasis,
            startDate
        };
    }

    const rewardStartDate = rewardPeriod ? LocalDate.parse(rewardPeriod.startDate) : "";

    return (
        <Container>
            <Controls>
                <BackButtonContainer>
                    <BackToPage destinationPage="HOME" path="/contribute"/>
                </BackButtonContainer>
                <AvailablePeriods
                    periods={availablePeriods}
                    onChangePeriod={(isCurrentSelection) => {
                        if (!isCurrentSelection) {
                            portfolioAuthorActions.reset();
                        }
                    }}
                    isSelectedPeriod={(periodBasis, startDate) => rewardPeriod && periodBasis === rewardPeriod.periodBasis && startDate === rewardPeriod.startDate}
                    periodPath={(periodBasis, startDate) => {
                        if (periodBasis === availablePeriods[availablePeriods.length - 1].periodBasis && startDate === availablePeriods[availablePeriods.length - 1].startDate) {
                            return `/contribute/${portfolioId}/${authorId}`;
                        }
                        else {
                            return `/contribute/${portfolioId}/${authorId}/period/${periodBasis}/${startDate}`;
                        }
                    }}
                    loggingPayloadFor={loggingPayloadFor}
                    viewingOnDate={viewingOnDate}
                />
            </Controls>
            <Details>
                <PortfolioDetails portfolioAuthor={portfolioAuthor}/>
                <PeriodMetric performancePeriodBasis={performancePeriod}
                              periodStartDate={performancePeriodStart}
                              rewardStartDate={rewardStartDate}
                              viewingOnDate={viewingOnDate}/>
                <AuthorKpiHeading portfolioAuthor={portfolioAuthor}/>
            </Details>
            <PortfolioMessage portfolioMessage={portfolioMessage}/>
        </Container>

    );
};

export default PortfolioAuthorHeader;